import React, { useEffect, useState } from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSync } from '@fortawesome/pro-duotone-svg-icons';
import Axios from 'axios';
import { endOfDay } from 'date-fns';
import { useSnackbar } from 'notistack';
import { TitleLabel } from '../../Element/LabelInputForm';
import { MySelect } from '../../Select/Select';
import {
   groups_mock,
   fields_mock,
   departments_mock,
   segments_mock,
   branches_mock,
} from '../../../mockdata/dashboard/mock-graph-1';
import { DatePicker } from 'react-nice-dates';
import { enUS } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import dayjs from 'dayjs';
import { Input } from '../../../assets/styled/Element';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';

const url = '/GSB/dashboard/dashboard/GetDashboardDropdownLevel6';
let mock = false;

const Filter6level = ({
   onSubmit,
   isLoading = false,
   defaultSubmitFirstParams = false,
   startDate = new Date(moment().subtract(2, 'years')),
   endDate = new Date(),
}) => {
   // snackbar
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   // dropdown options
   const [groups, setGroups] = useState([]);
   const [fields, setFields] = useState([]);
   const [departments, setDepartments] = useState([]);
   const [segments, setSegments] = useState([]);
   const [branches, setBranches] = useState([]);
   const [isLoadingGroups, setIsLoadingGroups] = useState(false);
   const [isLoadingFields, setIsLoadingFields] = useState(false);
   const [isLoadingDepartments, setIsLoadingDepartments] = useState(false);
   const [isLoadingSegments, setIsLoadingSegments] = useState(false);
   const [isLoadingBranches, setIsLoadingBranches] = useState(false);

   const {
      control,
      register,
      watch,
      setValue,
      getValues,
      handleSubmit,
      unsubscribe,
   } = useForm({
      defaultValues: {
         group: null,
         field: null,
         department: null,
         segment: null,
         branch: null,
         startDate: startDate,
         endDate: endDate,
      },
   });

   const selectedGroup = watch('group');
   const selectedField = watch('field');
   const selectedDepartment = watch('department');
   const selectedSegment = watch('segment');
   const selectedBranch = watch('branch');
   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');

   useEffect(() => {
      register({ name: 'group' });
      register({ name: 'field' });
      register({ name: 'department' });
      register({ name: 'segment' });
      register({ name: 'branch' });
      register({ name: 'startDate' });
      register({ name: 'endDate' });
   }, [register]);

   useEffect(() => {
      init();
   }, []);

   const init = () => {
      if (defaultSubmitFirstParams) {
         (async () => {
            await getGroupsDropdown().then((result) => {
               handleChangeGroup(result[0]);
            });
            handleSubmit(submit)();
         })();
      } else {
         getGroupsDropdown();
      }
   };

   // transform dropdown
   const toDropdownShortcode = (arr) => {
      return arr.map((el) => {
         return {
            data: el,
            label: el.formattedName,
            value: el.shortCode,
         };
      });
   };

   // get dropdown
   const getGroupsDropdown = () => {
      let payload = {
         divisionShortCode: [],
         level: 2,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(groups_mock);
            setGroups(temp);
         }, 100);
      } else {
         setIsLoadingGroups(true);
         return Axios.post(url, payload)
            .then((resp) => {
               let temp = toDropdownShortcode(resp.data);
               setGroups(temp);
               return temp;
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingGroups(false);
            });
      }
   };
   const getFieldsDropdown = (shortCodes) => {
      let payload = {
         divisionShortCode: shortCodes,
         level: 3,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(fields_mock);
            setFields(temp);
         }, 100);
      } else {
         setIsLoadingFields(true);
         Axios.post(url, payload)
            .then((resp) => {
               let temp = toDropdownShortcode(resp.data);
               setFields(temp);
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingFields(false);
            });
      }
   };
   const getDepartmentsDropdown = (shortCodes) => {
      let payload = {
         divisionShortCode: shortCodes,
         level: 4,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(departments_mock);
            setDepartments(temp);
         }, 100);
      } else {
         setIsLoadingDepartments(true);
         Axios.post(url, payload)
            .then((resp) => {
               let temp = toDropdownShortcode(resp.data);
               setDepartments(temp);
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingDepartments(false);
            });
      }
   };
   const getSegmentsDropdown = (shortCodes) => {
      let payload = {
         divisionShortCode: shortCodes,
         level: 5,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(segments_mock);
            setSegments(temp);
         }, 100);
      } else {
         setIsLoadingSegments(true);
         Axios.post(url, payload)
            .then((resp) => {
               let temp = toDropdownShortcode(resp.data);
               setSegments(temp);
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingSegments(false);
            });
      }
   };
   const getBranchesDropdown = (shortCodes) => {
      let payload = {
         divisionShortCode: shortCodes,
         level: 6,
         start: null,
         limit: null,
      };
      if (mock) {
         setTimeout(() => {
            let temp = toDropdownShortcode(branches_mock);
            setBranches(temp);
         }, 100);
      } else {
         setIsLoadingBranches(true);
         Axios.post(url, payload)
            .then((resp) => {
               let temp = toDropdownShortcode(resp.data);
               setBranches(temp);
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingBranches(false);
            });
      }
   };

   // on select dropdown
   const handleChangeGroup = (selected) => {
      const clearNext = () => {
         setValue('field', null);
         setValue('department', null);
         setValue('segment', null);
         setValue('branch', null);
         setFields([]);
         setDepartments([]);
         setSegments([]);
         setBranches([]);
      };
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         setValue('group', selected);
         shortCodes = selected.map((el) => el.value);
         getFieldsDropdown(shortCodes);
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('group') ||
            (getValues('group') && selected.value !== getValues('group').value)
         ) {
            setValue('group', selected);
            clearNext();
            shortCodes = [selected.value];
            getFieldsDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('group', null);
         clearNext();
      }
   };
   const handleChangeField = (selected) => {
      const clearNext = () => {
         setValue('department', null);
         setValue('segment', null);
         setValue('branch', null);
         setDepartments([]);
         setSegments([]);
         setBranches([]);
      };
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         setValue('field', selected);
         shortCodes = selected.map((el) => el.value);
         getDepartmentsDropdown(shortCodes);
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('field') ||
            (getValues('field') && selected.value !== getValues('field').value)
         ) {
            setValue('field', selected);
            clearNext();
            shortCodes = [selected.value];
            getDepartmentsDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('field', null);
         clearNext();
      }
   };
   const handleChangeDepartment = (selected) => {
      const clearNext = () => {
         setValue('segment', null);
         setValue('branch', null);
         setSegments([]);
         setBranches([]);
      };
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         setValue('department', selected);
         shortCodes = selected.map((el) => el.value);
         getSegmentsDropdown(shortCodes);
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('department') ||
            (getValues('department') &&
               selected.value !== getValues('department').value)
         ) {
            setValue('department', selected);
            clearNext();
            shortCodes = [selected.value];
            getSegmentsDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('department', null);
         clearNext();
      }
   };
   const handleChangeSegment = (selected) => {
      const clearNext = () => {
         setValue('branch', null);
         setBranches([]);
      };
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         setValue('segment', selected);
         shortCodes = selected.map((el) => el.value);
         getBranchesDropdown(shortCodes);
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('segment') ||
            (getValues('segment') &&
               selected.value !== getValues('segment').value)
         ) {
            setValue('segment', selected);
            clearNext();
            shortCodes = [selected.value];
            getBranchesDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('segment', null);
         clearNext();
      }
   };
   const handleChangeBranch = (selected) => {
      const clearNext = () => {};
      let shortCodes = [];
      if (selected && Array.isArray(selected)) {
         setValue('branch', selected);
         shortCodes = selected.map((el) => el.value);
         getBranchesDropdown(shortCodes);
      } else if (selected && typeof selected === 'object') {
         if (
            !getValues('branch') ||
            (getValues('branch') &&
               selected.value !== getValues('segment').value)
         ) {
            setValue('branch', selected);
            clearNext();
            shortCodes = [selected.value];
            getBranchesDropdown(shortCodes);
         } else {
            // on click old value
         }
      } else {
         // on click clear
         setValue('branch', null);
         clearNext();
      }
   };

   // on select date
   const handleStartDateChange = (e) => setValue('startDate', e);
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };

   const handleReset = () => {
      setGroups([]);
      setFields([]);
      setDepartments([]);
      setSegments([]);
      setBranches([]);
      setValue('group', null);
      setValue('field', null);
      setValue('department', null);
      setValue('segment', null);
      setValue('branch', null);
      setValue('startDate', startDate);
      setValue('endDate', endDate);
      init();
   };

   const submit = async (e) => {
      let params = e;

      /** build short codes */
      let shortCodes = null;
      if (e.branch) {
         shortCodes = e.branch;
      } else if (e.segment) {
         shortCodes = e.segment;
      } else if (e.department) {
         shortCodes = e.department;
      } else if (e.field) {
         shortCodes = e.field;
      } else if (e.group) {
         shortCodes = e.group;
      } else {
         shortCodes = null;
      }
      if (shortCodes) {
         if (Array.isArray(shortCodes)) {
            shortCodes = shortCodes.map((el) => el.value);
         } else {
            shortCodes = [shortCodes.value];
         }
      }
      params.shortCodes = shortCodes;
      params.startDateString = moment(e.startDate).format('DD/MM/YYYY');
      params.endDateString = moment(e.endDate).format('DD/MM/YYYY');

      onSubmit(params);
   };

   return (
      <form onSubmit={handleSubmit(submit)}>
         <Box fontSize={20}>
            <Grid container spacing={2}>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>เลือกกลุ่ม&nbsp;:&nbsp;</TitleLabel>
                  <MySelect
                     closeMenuOnSelect
                     options={groups}
                     placeholder={'เลือกกลุ่ม'}
                     isLoading={isLoadingGroups}
                     isDisabled={false}
                     value={selectedGroup}
                     onChange={handleChangeGroup}
                     isMulti={false}
                  />
               </Grid>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>เลือกสายงาน&nbsp;:&nbsp;</TitleLabel>
                  <MySelect
                     closeMenuOnSelect
                     options={fields}
                     placeholder={'เลือกสายงาน'}
                     isLoading={isLoadingFields}
                     isDisabled={!getValues('group')}
                     value={selectedField}
                     onChange={handleChangeField}
                     isMulti={false}
                  />
               </Grid>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>
                     เลือกฝ่าย/ภาค&nbsp;:&nbsp;
                  </TitleLabel>
                  <MySelect
                     closeMenuOnSelect
                     options={departments}
                     placeholder={'เลือกฝ่าย/ภาค'}
                     isLoading={isLoadingDepartments}
                     isDisabled={!getValues('field')}
                     value={selectedDepartment}
                     onChange={handleChangeDepartment}
                     isMulti={false}
                  />
               </Grid>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>
                     เลือกส่วน/เขต&nbsp;:&nbsp;
                  </TitleLabel>
                  <MySelect
                     closeMenuOnSelect
                     options={segments}
                     placeholder={'เลือกส่วน/เขต'}
                     isLoading={isLoadingSegments}
                     isDisabled={!getValues('department')}
                     value={selectedSegment}
                     onChange={handleChangeSegment}
                     isMulti={false}
                  />
               </Grid>
               <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>
                     เลือกหน่วยงาน/สาขา&nbsp;:&nbsp;
                  </TitleLabel>
                  <MySelect
                     closeMenuOnSelect
                     options={branches}
                     placeholder={'เลือกหน่วยงาน/สาขา'}
                     isLoading={isLoadingBranches}
                     isDisabled={!getValues('segment')}
                     value={selectedBranch}
                     onChange={handleChangeBranch}
                     isMulti={false}
                  />
               </Grid>
               <Grid item xs={2}>
                  <TitleLabel Fs={'14px'}>เริ่มต้น&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                     <DatePicker
                        date={selectStartDate}
                        onDateChange={handleStartDateChange}
                        locale={enUS}
                        maximumDate={getValues('endDate')}
                     >
                        {({ inputProps, focused }) => (
                           <Input
                              className={'input' + (focused ? ' -focused' : '')}
                              {...inputProps}
                              value={`${
                                 inputProps.value &&
                                 dayjs(new Date(inputProps.value)).format(
                                    'DD/MM/BBBB',
                                 )
                              }`}
                           />
                        )}
                     </DatePicker>
                  </Box>
               </Grid>
               <Grid item xs={2}>
                  <TitleLabel Fs={'14px'}>สิ้นสุด&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                     <DatePicker
                        date={selectEndDate}
                        onDateChange={handleEndDateChange('auto')}
                        minimumDate={
                           getValues('startDate')
                              ? getValues('startDate')
                              : new Date()
                        }
                        locale={enUS}
                     >
                        {({ inputProps, focused }) => (
                           <Input
                              className={'input' + (focused ? ' -focused' : '')}
                              {...inputProps}
                              value={`${
                                 inputProps.value &&
                                 dayjs(new Date(inputProps.value)).format(
                                    'DD/MM/BBBB',
                                 )
                              }`}
                           />
                        )}
                     </DatePicker>
                  </Box>
               </Grid>
            </Grid>
            <Grid container spacing={2}>
               <Grid item xs={12}>
                  <Button
                     variant={'contained'}
                     size={'small'}
                     color={'primary'}
                     type={'submit'}
                     startIcon={
                        isLoading ? (
                           <CircularProgress size={20} color={'primary'} />
                        ) : (
                           <FontAwesomeIcon icon={faSearch} size={'s'} />
                        )
                     }
                     disabled={isLoading}
                  >
                     ค้นหา
                  </Button>
                  <Button
                     variant={'contained'}
                     disableElevation
                     size={'small'}
                     onClick={handleReset}
                     startIcon={<FontAwesomeIcon icon={faSync} size={'s'} />}
                  >
                     รีเฟรช
                  </Button>
               </Grid>
            </Grid>
         </Box>
      </form>
   );
};

export default Filter6level;
